import { ThunkAction } from 'redux-thunk';

import * as CatalogClient from 'Clients/Catalog';
import * as ImagesClient from 'Clients/Images';
import { actions as paginatedActions } from 'Store/Search/Paginator';

export const RESETTING_CACHE = 'ADMIN_RESETTING_CACHE';
export const RESET_CACHE_SUCCESS = 'ADMIN_RESET_CACHE_SUCCESS';
export const RESET_CACHE_FAILED = 'ADMIN_RESET_CACHE_FAILED';

export interface AdminAction {
  type: string;
}

function resettingCache(): AdminAction {
  return {
    type: RESETTING_CACHE
  };
}

function resetCacheFailed(): AdminAction {
  return {
    type: RESET_CACHE_FAILED
  };
}

function resetCacheSuccess(): AdminAction {
  return {
    type: RESET_CACHE_SUCCESS
  };
}

export function resetCache(includeServerCache: boolean): ThunkAction<Promise<any>, any, any> {
  return (dispatch, getState) => {
    dispatch(resettingCache());

    const promise = includeServerCache ? Promise.all([
      CatalogClient.Util.resetServerCache(),
      ImagesClient.Util.resetCache()
    ]) : Promise.resolve();

    promise.then(
      c => {
        CatalogClient.Util.clearWebStorage();
        dispatch(paginatedActions.clear());
        dispatch(resetCacheSuccess());
      },
      e => dispatch(resetCacheFailed())
    );

    return promise;
  };
}

export function resetDesignCache(designCode: string): ThunkAction<Promise<any>, any, any> {
  return (dispatch, getState) => {
    const promise = Promise.all([
      CatalogClient.Util.resetDesignServerCache(designCode),
      ImagesClient.Util.resetDesignCache(designCode)
    ]);

    return promise;
  };
}
